export function debugLog(msg) {
    if (1 == 1 || process.env.MIX_FRONTEND_DEBUG === true) {
        if (typeof msg === 'object') {
            console.log('DEBUG: (object)...');
            console.log(msg);
        } else {
            console.log('DEBUG: ' + msg);
        }
    }
}
